import InfoCard from '@/components/ui/InfoCard';
import { CheckCircle } from 'lucide-react';
import { USER_ACTIONS_EMPTY_MESSAGE, USER_ACTIONS_UNAVAILABLE_MESSAGE } from '../../model/userActionMessages';
import { UserActionsEmptyStateProps } from './types';

const UserActionsEmptyState = (props: UserActionsEmptyStateProps) => {
  const {
    isError,
    variant
  } = props;

  const isShipmentVariant = variant === 'shipment';
  const iconClassName = isShipmentVariant ? 'size-4 text-muted-foreground' : 'size-6 text-muted-foreground';
  const message = isError ? USER_ACTIONS_UNAVAILABLE_MESSAGE : USER_ACTIONS_EMPTY_MESSAGE;

  return (
    <InfoCard
      description={message}
      icon={(
        <CheckCircle
          className={iconClassName}
          strokeWidth={1.25}
        />
      )}
      layout={isShipmentVariant ? 'row' : 'center'}
    />
  );
};

export default UserActionsEmptyState;